<!-- Compiled at 2026-09-18T12:45:23.821Z -->
<ng-container *ngIf="$isVariablesInitialized()">
	<ng-container *lowgileScope="null; screen: this; let $scope">
		<ng-container *lowgileForm="null; screen: this; let $formDirective">
			<div style="display: contents" [class.fill]="false">
				<ng-container *ngIf="screen.request"
					><ng-container
						*ngIf="screen.receivedOfferCount < screen.request.vendorOffers.length && screen.request.status.isRequested && !screen.request.status.isClosed && !screen.request.evaluationProcessId"
						><mat-card>
							<mat-card-header>
								<mat-card-title
									><span
										[innerHtml]="'Missing offers' | escapeHtml: 'none' | replaceNewlines: 'span'"
									></span
								></mat-card-title>
							</mat-card-header>

							<mat-card-content>
								<div
									class="layout-block vertical"
									[style.align-items]="'inherit'"
									[style.gap]="'1em'"
								>
									<span
										[innerHtml]="`Only ${screen.receivedOfferCount} of ${screen.request.vendorOffers.length} offers have been received. Wait or choose an action below` | escapeHtml: 'none' | replaceNewlines: 'span'"
									></span>
									<ng-container
										*ngrxLet="(!devBarService.isEnableEverything()) && (!!(false)) as $disabled"
									>
										<div
											class="layout-block"
											[style.align-items]="'inherit'"
											[class.horizontal]="Sys.Layout.sizeIsGreaterThanOrEqual.XSmall"
											[class.vertical]="Sys.Layout.sizeIsLessThan.XSmall"
											[style.gap]="'1em'"
										>
											<ng-container
												*ngrxLet="(!devBarService.isEnableEverything()) && ($disabled || !!(!screen.receivedOfferCount)) as $disabled"
											>
												<button
													mat-raised-button
													class="has-click-handler"
													color="primary"
													(click)="handler_ButtonBlock_124_click_$adhoc_0($event, { $disabled: $disabled })"
													[disabled]="$disabled"
												>
													<mat-icon>{{'skip_next'}}</mat-icon
													><span
														[innerHtml]="'Continue with the received offers' | escapeHtml: 'none' | replaceNewlines: 'span'"
													></span>
												</button>
											</ng-container>
											<button
												mat-raised-button
												class="has-click-handler"
												color="warn"
												(click)="handler_ButtonBlock_123_click_$adhoc_0($event, { $disabled: $disabled })"
												[disabled]="$disabled"
											>
												<mat-icon>{{'close'}}</mat-icon
												><span
													[innerHtml]="'Close customer request manually' | escapeHtml: 'none' | replaceNewlines: 'span'"
												></span>
											</button>
										</div>
									</ng-container>
								</div>
							</mat-card-content> </mat-card
					></ng-container>

					<ng-container
						*ngFor="let offer of screen.request.vendorOffers; let offerIndex = index; trackBy: trackByAutomatic"
					>
						<ng-container *lowgileScope="offer; as: 'offer'; let $scope">
							<ng-container *lowgileScope="offerIndex; as: 'offerIndex'; let $scope">
								<mat-card
									[style.background-color]="offer.id == screen.highlightOfferId ? 'gainsboro' : ''"
								>
									<mat-card-header>
										<mat-card-title
											><div
												class="layout-block fill"
												[style.align-items]="'inherit'"
												[class.horizontal]="Sys.Layout.sizeIsGreaterThanOrEqual.XSmall"
												[class.vertical]="Sys.Layout.sizeIsLessThan.XSmall"
												[style.gap]="'1em'"
											>
												<span
													[style.flex]="'1 0 auto'"
													[innerHtml]="`Offer from ${offer.vendor.name}` | escapeHtml: 'none' | replaceNewlines: 'span'"
												></span>
												<span
													[innerHtml]="`[${offer.offerNumber || offer.id}]` | escapeHtml: 'none' | replaceNewlines: 'span'"
												></span></div
										></mat-card-title>
									</mat-card-header>

									<mat-card-content>
										<ng-container *ngIf="offer.status.isReceived; else else130"
											><div
												class="layout-block"
												style="margin-top: 1em"
												[style.align-items]="'start'"
												[class.horizontal]="Sys.Layout.sizeIsGreaterThanOrEqual.XSmall"
												[class.vertical]="Sys.Layout.sizeIsLessThan.XSmall"
												[style.gap]="'1em'"
											>
												<span
													[style.flex]="'3 0 50%'"
													[innerHtml]="offer.bodyText | escapeHtml: 'safe' | replaceNewlines: 'span'"
												></span>
												<div
													class="layout-block vertical"
													[style.align-items]="'inherit'"
													[style.gap]="'1em'"
												>
													<ng-container
														*ngFor="let item of offer.items; let itemIndex = index; trackBy: trackByAutomatic"
													>
														<ng-container
															*lowgileScope="item; as: 'item'; let $scope"
														>
															<ng-container
																*lowgileScope="itemIndex; as: 'itemIndex'; let $scope"
															>
																<h3
																	[innerHtml]="item.requestItem.name | escapeHtml: 'none' | replaceNewlines: 'h3'"
																></h3>
																<lowgile-table
																	#datatable_97
																	[dataSignal]="_DataTableBlock_collectionCodeSignal_97(datatable_97, { app, screen, $pathSegments, $disabled, offer, offerIndex, item, itemIndex })"
																	[trackBy]="trackByAutomatic"
																	[columns]="_DataTableBlock_columns_97(screen)"
																	[showSettings]="false"
																	[userDefinedConfiguration]="undefined"
																	[usePaging]="false"
																	[pageSize]="999"
																	[pageSizeOptions]="[10, 20, 50]"
																	[useGlobalFilter]="false"
																	[debouncingDelay]="250"
																	[stickyHeader]="true"
																	[additionalFindOptions]="_DataTableBlock_additionalFindOptions_97({ app, screen, $pathSegments, $disabled, offer, offerIndex, item, itemIndex })"
																	[additionalHeaderRows]="[]"
																	[additionalFooterRows]="[]"
																	[allClasses]="$Modules"
																	[class.vertical]="Sys.Layout.sizeIsLessThan.XSmall"
																	[surroundingScope]="$scope"
																	#$table_97="lowgileTable"
																>
																	<ng-container
																		[lowgile-column]="'quantity'"
																	>
																		<th
																			mat-header-cell
																			*matHeaderCellDef
																		>
																			<span
																				[innerHtml]="'Quantity' | escapeHtml: 'none' | replaceNewlines: 'span'"
																			></span>
																		</th>
																		<td
																			mat-cell
																			*matCellDef="let quantity; let quantityIndex = index"
																			[attr.data-label]="'Quantity'"
																		>
																			<ng-container
																				*lowgileScope="quantity; as: 'quantity'; let $scope"
																			>
																				<ng-container
																					*lowgileScope="quantityIndex; as: 'quantityIndex'; let $scope"
																				>
																					<span
																						[innerHtml]="_DataTableColumnBlock_cellText_99({ app, screen, $pathSegments, $disabled, offer, offerIndex, item, itemIndex, quantity, quantityIndex }) | escapeHtml: 'none' | replaceNewlines: 'span'"
																					></span>
																				</ng-container>
																			</ng-container>
																		</td>
																	</ng-container>
																	<ng-container
																		[lowgile-column]="('quantity') + '$$filter'"
																	>
																		<th
																			mat-header-cell
																			*matHeaderCellDef
																		></th>
																	</ng-container>

																	<ng-container
																		[lowgile-column]="'unitPrice'"
																	>
																		<th
																			mat-header-cell
																			*matHeaderCellDef
																		>
																			<span
																				[innerHtml]="'Unit price' | escapeHtml: 'none' | replaceNewlines: 'span'"
																			></span>
																		</th>
																		<td
																			mat-cell
																			*matCellDef="let quantity; let quantityIndex = index"
																			[attr.data-label]="'Unit price'"
																		>
																			<ng-container
																				*lowgileScope="quantity; as: 'quantity'; let $scope"
																			>
																				<ng-container
																					*lowgileScope="quantityIndex; as: 'quantityIndex'; let $scope"
																				>
																					<div
																						class="layout-block vertical"
																						[style.align-items]="'inherit'"
																						[style.gap]="'0.25em'"
																					>
																						<span
																							[innerHtml]="`${offer.currency.label} ${Sys.Text.formatAsCurrency(quantity.unitPrice)}` | escapeHtml: 'none' | replaceNewlines: 'span'"
																						></span>
																						<ng-container
																							*ngIf="offer.discountPercent"
																							><span
																								[innerHtml]="`-${offer.discountPercent}% = ${offer.currency.label} ${Sys.Text.formatAsCurrency(quantity.unitPriceDiscounted)}` | escapeHtml: 'none' | replaceNewlines: 'span'"
																							></span
																						></ng-container>
																					</div>
																				</ng-container>
																			</ng-container>
																		</td>
																	</ng-container>
																	<ng-container
																		[lowgile-column]="('unitPrice') + '$$filter'"
																	>
																		<th
																			mat-header-cell
																			*matHeaderCellDef
																		></th>
																	</ng-container>

																	<ng-container
																		[lowgile-column]="'deliveryTime'"
																	>
																		<th
																			mat-header-cell
																			*matHeaderCellDef
																		>
																			<span
																				[innerHtml]="'Delivery time' | escapeHtml: 'none' | replaceNewlines: 'span'"
																			></span>
																		</th>
																		<td
																			mat-cell
																			*matCellDef="let quantity; let quantityIndex = index"
																			[attr.data-label]="'Delivery time'"
																		>
																			<ng-container
																				*lowgileScope="quantity; as: 'quantity'; let $scope"
																			>
																				<ng-container
																					*lowgileScope="quantityIndex; as: 'quantityIndex'; let $scope"
																				>
																					<span
																						[innerHtml]="_DataTableColumnBlock_cellText_113({ app, screen, $pathSegments, $disabled, offer, offerIndex, item, itemIndex, quantity, quantityIndex }) | escapeHtml: 'none' | replaceNewlines: 'span'"
																					></span>
																				</ng-container>
																			</ng-container>
																		</td>
																	</ng-container>
																	<ng-container
																		[lowgile-column]="('deliveryTime') + '$$filter'"
																	>
																		<th
																			mat-header-cell
																			*matHeaderCellDef
																		></th>
																	</ng-container>
																</lowgile-table>
															</ng-container>
														</ng-container>
													</ng-container>
													<span
														[innerHtml]="`Vendor shipping fees: ${offer.currency.label} ${Sys.Text.formatAsCurrency(offer.priceShipping)}` | escapeHtml: 'none' | replaceNewlines: 'span'"
													></span>
												</div></div
										></ng-container>
										<ng-template #else130>
											<span
												style="font-style: italic"
												[innerHtml]="'(Offer hasn\'t been received yet)' | escapeHtml: 'none' | replaceNewlines: 'span'"
											></span>
										</ng-template>
									</mat-card-content>
								</mat-card>
							</ng-container>
						</ng-container> </ng-container
				></ng-container>
			</div>
		</ng-container>
	</ng-container>
</ng-container>
